import {
  GET_DECKS,
  GET_DECK,
  ADD_DECK,
  UPDATE_DECK,
  DELETE_DECK,
  DECK_ERROR,
  CLEAR_DECKS,
  SET_CURRENT_DECK,
  CLEAR_CURRENT_DECK,
  ADD_CARD_TO_DECK,
  REMOVE_CARD_FROM_DECK,
  SEARCH_CARDS,
  CLEAR_SEARCH,
  CARD_ERROR,
  SET_ACTIVE_DECK,
  CLEAR_ACTIVE_DECK
} from '../types';

const deckReducer = (state, action) => {
  switch (action.type) {
    case GET_DECKS:
      return {
        ...state,
        decks: action.payload,
        loading: false
      };
    case GET_DECK:
      return {
        ...state,
        currentDeck: action.payload,
        loading: false
      };
    case ADD_DECK:
      return {
        ...state,
        decks: [action.payload, ...state.decks],
        loading: false
      };
    case UPDATE_DECK:
      return {
        ...state,
        decks: state.decks.map(deck =>
          deck._id === action.payload._id ? action.payload : deck
        ),
        currentDeck: action.payload,
        loading: false
      };
    case DELETE_DECK:
      return {
        ...state,
        decks: state.decks.filter(deck => deck._id !== action.payload),
        loading: false
      };
    case DECK_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    case CLEAR_DECKS:
      return {
        ...state,
        decks: [],
        currentDeck: null,
        loading: false
      };
    case SET_CURRENT_DECK:
      return {
        ...state,
        currentDeck: action.payload
      };
    case CLEAR_CURRENT_DECK:
      return {
        ...state,
        currentDeck: null
      };
    case ADD_CARD_TO_DECK:
      // Handling card addition is now done through UPDATE_DECK
      return state;
    case REMOVE_CARD_FROM_DECK:
      // Handling card removal is now done through UPDATE_DECK
      return state;
    case SEARCH_CARDS:
      return {
        ...state,
        searchResults: action.payload.cards || action.payload, // Support both new and old format
        paginationInfo: action.payload.pagination || {
          page: 1,
          pageSize: 20,
          totalCount: Array.isArray(action.payload) ? action.payload.length : 0,
          totalPages: 1
        },
        loading: false
      };
    case CLEAR_SEARCH:
      return {
        ...state,
        searchResults: [],
        paginationInfo: {
          page: 1,
          pageSize: 20,
          totalCount: 0,
          totalPages: 1
        }
      };
    case CARD_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    case SET_ACTIVE_DECK:
      return {
        ...state,
        activeDeckId: action.payload,
        loading: false
      };
    case CLEAR_ACTIVE_DECK:
      return {
        ...state,
        activeDeckId: null
      };
    default:
      return state;
  }
};

export default deckReducer;
